import { ProductType } from "@obg/ngx.core";
import { QueryParams } from "@obg/ngx.router";

export const enum GamingRoutes {
	GameFrame = "game-frame",
	GameFrameAutoplay = "game-frame-autoplay",
	GameLauncher = "game-launcher",
	GameLauncherAutoplay = "game-launcher-autoplay",
	Search = "search",
	Favorites = "favorites",
	RecommendedGames = "recommended-games",
	Categories = "categories",
	CasinoTournaments = "casino-tournaments",
	Recommended = "recommended-games",
	GamesAZ = "atoz",
}

export const CASINO_ROUTES = {
	lobby: `${ProductType.Casino}`,
	gameFrameAutoplay: `${ProductType.Casino}.${GamingRoutes.GameFrameAutoplay}`,
	gameLauncher: `${ProductType.Casino}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.Casino}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.Casino}.${GamingRoutes.Search}`,
	favorites: `${ProductType.Casino}.${GamingRoutes.Favorites}`,
	recommended: `${ProductType.Casino}.${GamingRoutes.Recommended}`,
	categories: `${ProductType.Casino}.${GamingRoutes.Categories}`,
	casinoTournaments: `${ProductType.Casino}.${GamingRoutes.CasinoTournaments}`,
	gamesAZ: `pages.${ProductType.Casino}.${GamingRoutes.GamesAZ}`,
};

export const JACKPOTS_ROUTES = {
	lobby: `${ProductType.Jackpots}`,
	gameLauncher: `${ProductType.Jackpots}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.Jackpots}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.Jackpots}.${GamingRoutes.Search}`,
	favorites: `${ProductType.Jackpots}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.Jackpots}.${GamingRoutes.Categories}`,
	casinoTournaments: `${ProductType.Jackpots}.${GamingRoutes.CasinoTournaments}`,
};

export const SLOTS_ROUTES = {
	lobby: `${ProductType.Slots}`,
	gameLauncher: `${ProductType.Slots}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.Slots}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.Slots}.${GamingRoutes.Search}`,
	favorites: `${ProductType.Slots}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.Slots}.${GamingRoutes.Categories}`,
};

export const SKILL_GAMES_ROUTES = {
	lobby: `${ProductType.SkillGames}`,
	gameLauncher: `${ProductType.SkillGames}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.SkillGames}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.SkillGames}.${GamingRoutes.Search}`,
	favorites: `${ProductType.SkillGames}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.SkillGames}.${GamingRoutes.Categories}`,
};

export const LIVE_CASINO_ROUTES = {
	lobby: `${ProductType.LiveCasino}`,
	gameLauncher: `${ProductType.LiveCasino}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.LiveCasino}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.LiveCasino}.${GamingRoutes.Search}`,
	favorites: `${ProductType.LiveCasino}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.LiveCasino}.${GamingRoutes.Categories}`,
	casinoTournaments: `${ProductType.LiveCasino}.${GamingRoutes.CasinoTournaments}`,
	liveGamesAZ: `pages.${ProductType.LiveCasino}.${GamingRoutes.GamesAZ}`,
};

export const KENO_ROUTES = {
	lobby: `${ProductType.Keno}`,
	gameLauncher: `${ProductType.Keno}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.Keno}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.Keno}.${GamingRoutes.Search}`,
	favorites: `${ProductType.Keno}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.Keno}.${GamingRoutes.Categories}`,
};

export const MINI_GAME_ROUTES = {
	lobby: `${ProductType.MiniGames}`,
	gameLauncher: `${ProductType.MiniGames}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.MiniGames}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.MiniGames}.${GamingRoutes.Search}`,
	favorites: `${ProductType.MiniGames}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.MiniGames}.${GamingRoutes.Categories}`,
};

export const TABLE_GAME_ROUTES = {
	lobby: `${ProductType.TableGames}`,
	gameLauncher: `${ProductType.TableGames}.${GamingRoutes.GameLauncher}`,
	gameLauncherAutoplay: `${ProductType.TableGames}.${GamingRoutes.GameLauncherAutoplay}`,
	search: `${ProductType.TableGames}.${GamingRoutes.Search}`,
	favorites: `${ProductType.TableGames}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.TableGames}.${GamingRoutes.Categories}`,
};

export const TOURNAMENT_ROUTES = {
	root: "tournaments",
	upcoming: "tournaments.upcoming",
	active: "tournaments.active",
	ended: "tournaments.ended",
};

export const VIRTUAL_SPORTS_ROUTES = {
	lobby: `${ProductType.VirtualSports}`,
	gameLauncher: `${ProductType.VirtualSports}.${GamingRoutes.GameLauncher}`,
	search: `${ProductType.VirtualSports}.${GamingRoutes.Search}`,
	favorites: `${ProductType.VirtualSports}.${GamingRoutes.Favorites}`,
	categories: `${ProductType.VirtualSports}.${GamingRoutes.Categories}`,
};

export const SPORTSBOOK_THIRDPARTY_ROUTES = {
	lobby: `${ProductType.SportsbookThirdparty}`,
	destination: `${ProductType.SportsbookThirdparty}.destination`,
	event: `${ProductType.SportsbookThirdparty}.event`,
	subevent: `${ProductType.SportsbookThirdparty}.subevent`,
};

export const SPORTSBOOK_THIRDPARTY_LIVE_ROUTES = {
	lobby: `${ProductType.SportsbookThirdpartyLive}`,
	event: `${ProductType.SportsbookThirdpartyLive}.event`,
};

export const POKER_ROUTES = {
	lobby: `${ProductType.Poker}`,
	game: `${ProductType.Poker}.game`,
	alias: `${ProductType.Poker}.alias`,
	tournaments: `${ProductType.Poker}.tournaments`,
	achievements: `${ProductType.Poker}.achievements`,
	tournamentsAbout: `${ProductType.Poker}.tournamentsAbout`,
	tournamentsSitAndGo: `${ProductType.Poker}.tournamentsSitAndGo`,
	tournamentsScheduled: `${ProductType.Poker}.tournamentsScheduled`,
	tournamentsRules: `${ProductType.Poker}.tournamentsRules`,
	tournamentsTwister: `${ProductType.Poker}.tournamentsTwister`,
	loyaltyPoints: `${ProductType.Poker}.loyaltyPoints`,
	tournamentsOverview: `${ProductType.Poker}.tournamentsOverview`,
	pokerRules: `${ProductType.Poker}.pokerRules`,
	gameLauncher: `${ProductType.Poker}.${GamingRoutes.GameLauncher}`,
	search: `${ProductType.Poker}.${GamingRoutes.Search}`,
	categories: `${ProductType.Poker}.${GamingRoutes.Categories}`,
};

export const TURKISH_POKER_ROUTES = {
	lobby: `${ProductType.TurkishPoker}`,
	gameLauncher: `${ProductType.TurkishPoker}.${GamingRoutes.GameLauncher}`,
	game: `${ProductType.TurkishPoker}.game`,
	alias: `${ProductType.TurkishPoker}.alias`,
	tournaments: `${ProductType.TurkishPoker}.tournaments`,
	achievements: `${ProductType.TurkishPoker}.achievements`,
	tournamentsAbout: `${ProductType.TurkishPoker}.tournamentsAbout`,
	tournamentsSitAndGo: `${ProductType.TurkishPoker}.tournamentsSitAndGo`,
	tournamentsScheduled: `${ProductType.TurkishPoker}.tournamentsScheduled`,
	tournamentsRules: `${ProductType.TurkishPoker}.tournamentsRules`,
	loyaltyPoints: `${ProductType.TurkishPoker}.loyaltyPoints`,
	tournamentsOverview: `${ProductType.TurkishPoker}.tournamentsOverview`,
	pokerRules: `${ProductType.TurkishPoker}.pokerRules`,
	search: `${ProductType.TurkishPoker}.${GamingRoutes.Search}`,
	categories: `${ProductType.TurkishPoker}.${GamingRoutes.Categories}`,
};

export const PRODUCT_BLOCK_ROUTE = {
	productBlock: "product-block",
};

export const GAMING_ROUTE_MAP: Record<string, Record<string, string>> = {
	[ProductType.Casino]: CASINO_ROUTES,
	[ProductType.LiveCasino]: LIVE_CASINO_ROUTES,
	[ProductType.MiniGames]: MINI_GAME_ROUTES,
	[ProductType.TableGames]: TABLE_GAME_ROUTES,
	[ProductType.Keno]: KENO_ROUTES,
	[ProductType.VirtualSports]: VIRTUAL_SPORTS_ROUTES,
	[ProductType.Poker]: POKER_ROUTES,
	[ProductType.TurkishPoker]: TURKISH_POKER_ROUTES,
	[ProductType.Jackpots]: JACKPOTS_ROUTES,
	[ProductType.Slots]: SLOTS_ROUTES,
	[ProductType.SkillGames]: SKILL_GAMES_ROUTES,
};

export const GAMING_GAME_LAUNCHERS = [
	CASINO_ROUTES.gameLauncher,
	JACKPOTS_ROUTES.gameLauncher,
	SLOTS_ROUTES.gameLauncher,
	SKILL_GAMES_ROUTES.gameLauncher,
	KENO_ROUTES.gameLauncher,
	LIVE_CASINO_ROUTES.gameLauncher,
	MINI_GAME_ROUTES.gameLauncher,
	POKER_ROUTES.gameLauncher,
	TABLE_GAME_ROUTES.gameLauncher,
	TURKISH_POKER_ROUTES.gameLauncher,
];

export interface GamingStateParams {
	game?: string;
	category?: string;
}

export interface PokerStateParams extends QueryParams {
	providerId: string;
}
